import axios from "../axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 * @returns {Function}
 */
export const clearErrors = () => {
  return dispatch => {
    dispatch({type: "CLEAR_ERRORS"});
  }
};

/**
 *
 * @returns {function(*): Promise<AxiosResponse<T> | never>}
 */
export const fetchUserData = () => {
  return dispatch => {

    dispatch({type: "USER_DATA_FETCH"});

    const url = AxiosConfig.getEndpointAddress() + '/userdata';

    return axios.get(
      url,
      AxiosConfig.getConfig(),
    )
      .then((response) => {

        dispatch({
          type: "USER_DATA_FETCH_FULFILLED",
          data: response.data,
        });

      })
      .catch(function (error) {

        dispatch({
          type: "USER_DATA_FETCH_REJECTED",
          data: error,
        });

      });
  }
};
